import { createSelector } from "reselect";
import { selectData } from "state/issueCount/selectors";
import SelectionState from "state/selections/SelectionState";
import scope from "./scope";
import { isDefined, memoize, uniqueByKey } from "@ls/js-utils";
import SummaryType from "state/selections/Constants/SummaryType";

export const selectDefinitions = memoize((selectionState) => {
  if (selectionState === SelectionState.UNCOMMITTED) {
    return (state) => state[scope]["definitions"][selectionState];
  }

  return createSelector(
    (state) => state[scope]["definitions"][selectionState],
    (definitions) => {
      const completeDefinitions = definitions.filter(
        ({ complete }) => complete
      );
      return completeDefinitions.filter(
        uniqueByKey(completeDefinitions, "key")
      );
    }
  );
});

export const selectRowsMap = createSelector(
  selectDefinitions(SelectionState.COMMITTED),
  selectData(SummaryType.ABSOLUTE),
  selectData(SummaryType.RELATIVE),
  (issuerCountDefinitions, absData, relData) => {
    const entityRowsMap = {};
    const toRowsMap = (groupingData, definitions) => {
      if (groupingData?.root?.entitySummaries && definitions?.length) {
        groupingData.root.entitySummaries.forEach((entitySummary) => {
          const { entityId /*relative todo*/ } =
            entitySummary.entityResultMetaData;
          const { issuerCounts = [] } = entitySummary;

          definitions.forEach((issuerCountDef) => {
            const issuerCountObj = issuerCounts.find(
              (issuerCountObj) =>
                issuerCountObj.type === issuerCountDef.issuerCountType
            );
            if (!isDefined(entityRowsMap[entityId])) {
              entityRowsMap[entityId] = {};
            }
            if (issuerCountObj) {
              const { issuerCountType, summary } = issuerCountDef;
              entityRowsMap[entityId][
                `${scope}, ${issuerCountType}, ${summary}`
              ] = issuerCountObj.issuerCount;
            }
          });
        });
      }

      return entityRowsMap;
    };

    const absRowsMap = toRowsMap(
      absData,
      issuerCountDefinitions.filter(
        ({ summary }) => summary === SummaryType.ABSOLUTE
      )
    );
    const relRowsMap = toRowsMap(
      relData,
      issuerCountDefinitions.filter(
        ({ summary }) => summary === SummaryType.RELATIVE
      )
    );

    const result = { ...absRowsMap };
    Object.entries(relRowsMap).forEach(([entityId, relFields]) => {
      if (!result[entityId]) {
        result[entityId] = {};
      }
      result[entityId] = {
        ...result[entityId],
        ...relFields,
      };
    });
    return result;
  }
);
